import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getContractorUpdateProfile = createAsyncThunk(
  "contractorUpdateProfile/getContractorUpdateProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const contractorProfileUpdateSlice = createSlice({
  name: "contractorUpdateProfile",
  initialState: {
    loading: false,
    contractorUpdateProfileData: null,
    error: null,
  },
  reducers: {
    ResetContractorUpdateState: (state) => {
      state.loading = false;
      state.contractorUpdateProfileData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContractorUpdateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorUpdateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorUpdateProfileData = action.payload;
      })
      .addCase(getContractorUpdateProfile.rejected, (state, action) => {
        state.loading = false;
        state.contractorUpdateProfileData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetContractorUpdateState } =
contractorProfileUpdateSlice.actions;
export default contractorProfileUpdateSlice.reducer;
